﻿// client.js

import axios from 'axios';

let _errorCallback;
let _unauthorized;

const getAccessToken = function () {
    if (sessionStorage.getItem("accessToken")) {
        var token = JSON.parse(sessionStorage.getItem("accessToken"));
        if (token) {
            return token.accessToken;
        }
    }
    return null;
};

const axiosInstance = axios.create({
    baseURL: document.getElementsByTagName('base')[0].getAttribute("href"), //use base which is set by asp based on virtual dir
    /* other custom settings */
    headers: { Authorization: `Bearer ` + getAccessToken() }
});

axiosInstance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    //console.error(error);

    if (error.response.status === 401) {      
        //not logged in 
        _unauthorized(error.response);
    }

    if (error.response.status === 403) {
        //only callback when unauthorized matches is for the route configured to prevent multiple reroute. 
        _unauthorized(error.response);
    }

    if (_errorCallback)
        _errorCallback(error.message, error)

    return Promise.reject(error);
});

axiosInstance.unauthorized = (callback) => {
    _unauthorized = callback;
}

axiosInstance.onError = (callback) => {
    _errorCallback = callback;
}

axiosInstance.onError = (callback) => {
    _errorCallback = callback;
}

axiosInstance.validateCaptcha = (action) => {
    const captchaKey = app.settings.captchaPublicKey;
    
    if (!captchaKey) return Promise.resolve(null);
    
    return new Promise((resolve) => {
        grecaptcha.ready(function() {
            grecaptcha.execute(captchaKey, {action})
                .then(resolve);
        });    
    });
}

export default axiosInstance;